import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import useLinkProps from '../../../hooks/use-link-props';
import saveUserCars from '../../../services/user/save-cars';
import { useAppContext } from '../../providers/app-context';
import useSelectVehicle from '../../modules/vehicle-picker/use-selected-vehicle';

const useBreadcrumbItems = ({ productDetail, categoriesInfo }) => {
  const getLinks = useLinkProps();
  const { features } = useAppContext();
  const { t } = useTranslation();
  const { locale = 'en' } = useRouter();
  const setUserVehicle = useSelectVehicle();

  if (!!categoriesInfo.category && !!categoriesInfo.subCategory) {
    return [
      {
        ...getLinks('categories'),
        text: t('common:partscatalog'),
      },
      {
        ...getLinks('sub-categories', {
          category: productDetail.part.subgroup_slug,
        }),
        text: `${categoriesInfo.category} - ${categoriesInfo.subCategory}`,
      },
      !features.isBrandEnabled && {
        ...getLinks('brands-with-part', {
          category: productDetail.part.subgroup_slug,
          subCategory: productDetail.part.slug,
        }),
        text: t('common:brand.other'),
      },
      {
        ...getLinks('models-with-part', {
          brand: productDetail.car.brand_slug,
          category: productDetail.part.subgroup_slug,
          subCategory: productDetail.part.slug,
        }),
        text: `${productDetail.car.brand_name}`,
      },
      // model only car => go to product list
      !productDetail.car.model_have_versions && {
        ...getLinks('search', {
          category: productDetail.part.subgroup_slug,
          subCategory: productDetail.part.slug,
          vehicle: productDetail.car.model_slug,
        }),
        text: `${productDetail.car.model_name}`,
        onClick: () => {
          setUserVehicle(productDetail.car.model_slug)
        }
      },
      // uncomplete car selection => go to versions page
      productDetail.car.model_have_versions && {
        ...getLinks('versions-with-part', {
          model: productDetail.car.model_slug,
          category: productDetail.part.subgroup_slug,
          subCategory: productDetail.part.slug,
        }),
        text: `${productDetail.car.model_name}`,
      },
      // car with version has selection completed
      productDetail.car.model_have_versions &&
      productDetail.car.version_slug && {
        ...getLinks('search', {
          category: productDetail.part.subgroup_slug,
          subCategory: productDetail.part.slug,
          vehicle: productDetail.car.version_slug,
        }),
        text: `${productDetail.car.version_name}`,
        onClick: () => {
          setUserVehicle(productDetail.car.version_slug)
        }
      },
    ].filter(Boolean);
  } else {
    return [
      {
        ...getLinks('categories'),
        text: t('common:partscatalog'),
      },
      !features.isBrandEnabled && {
        ...getLinks('brands'),
        text: t('common:brand.other'),
      },
      {
        ...getLinks('models', {
          brand: productDetail.car.brand_slug,
        }),
        text: `${productDetail.car.brand_name}`,
      },
      // uncomplete car selection => go to versions page
      productDetail.car.model_have_versions && {
        ...getLinks('versions', {
          model: productDetail.car.model_slug,
        }),
        text: `${productDetail.car.model_name}${productDetail.car.version_slug
          ? ' ' + productDetail.car.version_name
          : ''
          }`,
      },
    ].filter(Boolean);
  }
};

export default useBreadcrumbItems;
